<template>
  <transition name="el-zoom-in-top" @after-leave="$emit('dodestroy')">
    <div
      v-show="visible"
      id="kye-date-picker2_month-panel"
      class="el-picker-panel el-date-range-picker el-popper kye-date-picker2-month_panel"
      :class="[
        {
          'has-sidebar': $slots.sidebar || shortcuts
        },
        popperClass
      ]"
    >
      <div class="kye-date-picker2-flex">
        <slot name="sidebar"></slot>
        <ShortcutsWrap
          v-if="showShortcuts"
          :type="type"
          :shortcuts="shortcuts"
          :handleShortcutClick="handleShortcutClick"
          currentView="month"
          :disabledMonth="disabledMonth"
        ></ShortcutsWrap>
        <div class="el-picker-panel__body-wrapper">
          <div class="el-picker-panel__body">
            <div
              class="el-picker-panel__content el-date-range-picker__content is-left"
            >
              <div
                class="el-date-range-picker__header kye-date-picker2-header-wrap bt-none month"
                :class="[showLocator ? 'flex-sb' : 'flex-center']"
              >
                <div class="left-wrap m-w-134">
                  <button
                    type="button"
                    @click="leftPrevYear"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-left"
                  ></button>
                  <YearSelect
                    @pick="handleYearPick($event, 'leftDate')"
                    :default-value="
                      defaultValue ? new Date(defaultValue) : null
                    "
                    :date="leftDate"
                    :endDate="rightDate"
                    :disabled-date="disabledDate"
                  >
                  </YearSelect>
                  <button
                    type="button"
                    @click="leftNextYear"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-right"
                  ></button>
                </div>
                <kye-button
                  v-if="showLocator"
                  @click="locatorToToday('leftDate')"
                  class="locator-today"
                  type="text"
                >
                  定位到当月
                </kye-button>
              </div>
              <div
                class="el-picker-panel__content kye-date-picker2-date-table-wrap month"
              >
                <month-table
                  selection-mode="range"
                  :date="leftDate"
                  :default-value="defaultValue"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :range-state="rangeState"
                  :disabled-date="disabledDate"
                  :cell-class-name="cellClassName"
                  @changerange="handleChangeRange"
                  @pick="handleRangePick"
                >
                </month-table>
              </div>
            </div>
            <div
              class="el-picker-panel__content el-date-range-picker__content is-right"
            >
              <div
                class="el-date-range-picker__header kye-date-picker2-header-wrap bt-none month"
                :class="[showLocator ? 'flex-sb' : 'flex-center']"
              >
                <div class="left-wrap m-w-134">
                  <button
                    type="button"
                    @click="rightPrevYear"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-left"
                  ></button>
                  <YearSelect
                    @pick="handleYearPick($event, 'rightDate')"
                    :default-value="
                      defaultValue ? new Date(defaultValue) : null
                    "
                    :date="rightDate"
                    :startDate="leftDate"
                    :disabled-date="disabledDate"
                  >
                  </YearSelect>
                  <button
                    type="button"
                    @click="rightNextYear"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-right"
                  ></button>
                </div>
                <kye-button
                  v-if="showLocator"
                  @click="locatorToToday('rightDate')"
                  class="locator-today"
                  type="text"
                >
                  定位到当月
                </kye-button>
              </div>
              <div
                class="el-picker-panel__content kye-date-picker2-date-table-wrap month"
              >
                <month-table
                  selection-mode="range"
                  :date="rightDate"
                  :default-value="defaultValue"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :range-state="rangeState"
                  :disabled-date="disabledDate"
                  :cell-class-name="cellClassName"
                  @changerange="handleChangeRange"
                  @pick="handleRangePick"
                >
                </month-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
import moment from 'moment'
import {
  isDate,
  modifyWithTimeString,
  prevYear,
  nextYear,
  nextMonth,
  changeYearMonthAndClampDate
} from '../utils'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import Locale from 'element-ui/lib/mixins/locale'
import MonthTable from '../basic/month-table'
import ShortcutsWrap from '../basic/shortcuts-wrap'
import YearSelect from '../basic/year-select'

const calcDefaultValue = (defaultValue) => {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])]
  } else if (defaultValue) {
    return [new Date(defaultValue), nextMonth(new Date(defaultValue))]
  } else {
    return [new Date(), nextMonth(new Date())]
  }
}
export default {
  mixins: [Locale],

  directives: { Clickoutside },

  computed: {
    btnDisabled() {
      return !(
        this.minDate &&
        this.maxDate &&
        !this.selecting &&
        this.isValidValue([this.minDate, this.maxDate])
      )
    },

    leftYear() {
      return this.leftDate.getFullYear()
    },

    rightYear() {
      return this.rightDate.getFullYear() === this.leftDate.getFullYear()
        ? this.leftDate.getFullYear() + 1
        : this.rightDate.getFullYear()
    },

    enableYearArrow() {
      return this.unlinkPanels && this.rightYear > this.leftYear + 1
    }
  },

  data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: '',
      maxDate: '',
      leftDate: new Date(),
      rightDate: nextYear(new Date()),
      rangeState: {
        endDate: null,
        selecting: false,
        row: null,
        column: null
      },
      shortcuts: [],
      visible: '',
      disabledDate: '',
      disabledMonth: '',
      cellClassName: '',
      format: '',
      arrowControl: false,
      unlinkPanels: false,
      showShortcuts: true,
      showLocator: true,
      type: 'month',
      activeInputIndex: 0
    }
  },

  watch: {
    value(newVal) {
      if (!newVal) {
        this.minDate = null
        this.maxDate = null
      } else if (Array.isArray(newVal)) {
        this.minDate = isDate(newVal[0]) ? new Date(newVal[0]) : null
        this.maxDate = isDate(newVal[1]) ? new Date(newVal[1]) : null
        if (this.minDate) {
          this.leftDate = this.minDate
          if (this.unlinkPanels && this.maxDate) {
            const minDateYear = this.minDate.getFullYear()
            const maxDateYear = this.maxDate.getFullYear()
            this.rightDate =
              minDateYear === maxDateYear
                ? nextYear(this.maxDate)
                : this.maxDate
          } else {
            this.rightDate = nextYear(this.leftDate)
          }
        } else {
          this.leftDate = calcDefaultValue(this.defaultValue)[0]
          this.rightDate = nextYear(this.leftDate)
        }
      }
    },

    defaultValue(val) {
      if (!Array.isArray(this.value)) {
        const [left, right] = calcDefaultValue(val)
        this.leftDate = left
        this.rightDate =
          val &&
          val[1] &&
          left.getFullYear() !== right.getFullYear() &&
          this.unlinkPanels
            ? right
            : nextYear(this.leftDate)
      }
    }
  },

  methods: {
    handleClear() {
      this.minDate = null
      this.maxDate = null
      this.leftDate = calcDefaultValue(this.defaultValue)[0]
      this.rightDate = nextYear(this.leftDate)
      this.$emit('pick', null)
    },

    handleChangeRange(val) {
      this.minDate = val.minDate
      this.maxDate = val.maxDate
      this.rangeState = val.rangeState
    },

    handleRangePick(val, close = true) {
      const defaultTime = this.defaultTime || []
      const minDate = modifyWithTimeString(val.minDate, defaultTime[0])
      const maxDate = modifyWithTimeString(val.maxDate, defaultTime[1])
      this.handleDateMouseEnter({
        newDate: this.activeInputIndex === 0 ? [val.minDate] : [val.maxDate],
        isDateRangePick: !this.isValidValue([minDate, maxDate]),
        val
      })
      if (this.maxDate === maxDate && this.minDate === minDate) {
        return
      }
      this.onPick && this.onPick(val)
      this.maxDate = maxDate
      this.minDate = minDate

      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
      setTimeout(() => {
        this.maxDate = maxDate
        this.minDate = minDate
      }, 10)
      if (!close) return
      this.handleConfirm()
    },

    handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this)
      } else if (typeof shortcut.value === 'function') {
        const [minDate, maxDate] = shortcut.value() || []
        this.handleRangePick({ minDate, maxDate }, true)
      }
    },

    // leftPrev*, rightNext* need to take care of `unlinkPanels`
    leftPrevYear() {
      this.leftDate = prevYear(this.leftDate)
      if (!this.unlinkPanels) {
        this.rightDate = prevYear(this.rightDate)
      }
    },

    rightNextYear() {
      this.rightDate = nextYear(this.rightDate)
    },

    leftNextYear() {
      this.leftDate = nextYear(this.leftDate)
      if (moment(this.leftDate).isAfter(moment(this.rightDate))) {
        this.rightDate = nextYear(this.rightDate)
      }
    },

    rightPrevYear() {
      this.rightDate = prevYear(this.rightDate)
    },

    handleConfirm(visible = false) {
      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$emit('pick', [this.minDate, this.maxDate], visible)
      }
    },

    isValidValue(value) {
      return (
        Array.isArray(value) &&
        value &&
        value[0] &&
        value[1] &&
        isDate(value[0]) &&
        isDate(value[1]) &&
        value[0].getTime() <= value[1].getTime() &&
        (typeof this.disabledDate === 'function'
          ? !this.disabledDate(value[0]) && !this.disabledDate(value[1])
          : true)
      )
    },

    resetView() {
      // NOTE: this is a hack to reset {min, max}Date on picker open.
      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
      this.minDate =
        this.value && isDate(this.value[0]) ? new Date(this.value[0]) : null
      this.maxDate =
        this.value && isDate(this.value[0]) ? new Date(this.value[1]) : null
    },
    locatorToToday(type) {
      this[type] = new Date()
    },
    handleYearPick(year, type) {
      const month = this[type].getMonth()
      this[type] = changeYearMonthAndClampDate(this[type], year, month)
    }
  },

  components: {
    MonthTable,
    ShortcutsWrap,
    YearSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker2/src/panel/month-range.vue